import React from "react";
import { useI18n, LANGS } from "../i18n";

export default function LangSwitch({ className = "" }) {
  const { lang, setLang } = useI18n();

  const pick = (l) => {
    setLang(l);
    const url = new URL(window.location.href);
    url.searchParams.set("lang", l);
    window.history.replaceState({}, "", url);
  };

  return (
    <div className={`inline-flex items-center border border-[#E2E0D8] ${className}`} data-testid="lang-switch">
      {LANGS.map((l) => (
        <button
          key={l}
          onClick={() => pick(l)}
          data-testid={`lang-${l}`}
          aria-pressed={lang === l}
          className={`mono text-[10px] px-2 py-2 transition-colors duration-300 ${
            lang === l ? "bg-[#141414] text-[#FAFAFA]" : "text-[#141414]/60 hover:text-[#141414]"
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
